import { Route, Switch } from 'react-router-dom';
import UserList from '@nkr/views/users/user-list';
import GroupList from '@nkr/views/users/group-list';
import DutyOfficerSchedule from '@nkr/views/admin/duty-officer-schedule';
import Products from '@nkr/views/admin/crm/products'
import RccapContainer from '@nkr/views/rccap/admin';
import RccapAddEdit from '@nkr/views/rccap/admin/rccap-add-edit';
import AccountPlan from '@nkr/views/admin/crm/account-plan';
import Hla from '@nkr/views/hla';
import DonorIntake from '@nkr/views/donors/donor-intake';
import WageAndTravel from '@nkr/views/donors/watr';
import PhlebotReport from '@nkr/views/phlebot-tracking';
import CenterContainer from '@nkr/views/admin/center/list';
import EmailContainer from '@nkr/views/admin/email';
import NetworkEmailSentList from '@nkr/views/admin/email/sent';
import OpsSchedule from '@nkr/views/admin/ops-schedule';
import CronJobs from '@nkr/views/admin/automated-jobs';
import AdminCenterUnosData from '@nkr/views/admin/update-optn-srtr-data/admin-center-unos-data';
import RecipientSearch from '@nkr/views/admin/recipient-search/index';
import DashLanguageVariable from '@nkr/views/dash/multilingual';
import SwapManagement from '@nkr/views/swap-management';
import OpoList from '@nkr/views/admin/opo/list';
import GpsContainer from '@nkr/views/admin/gps/container';
import CenterNotifications from "@nkr/views/admin/center/notifications";
import VoucherHolderAddEdit from '@nkr/views/voucher-holder/add-edit';
import RecipientProfile from '@nkr/views/recipients/profile';
import RecipientList from '@nkr/views/recipients/list/admin';
import VoucherHolders from '@nkr/views/voucher-holder/list';
import Donors from '@nkr/views/donors/swap-donors';
import SerologyTracking from '@nkr/views/admin/serology-tracking';
import OrderTracking from './order-tracking';
import ActionCenter from '@nkr/views/admin/action-center';
import HardToMatch from '@nkr/views/admin/hard-to-match/hard-to-match';
import NotFound from '../../config/not-found';
import AdminList from '@nkr/views/recipients/patient-intake/list/admin-list';
import {
    AdminAllCentersClcReportRoutes,
    AdminCenterProfileRoutes,
    AdminFollowUpRoutes,
    AdminInvoiceRoutes,
    AdminMicrositeRoutes,
    AdminReportRoutes,
    AdminVoucherBookRoutes,
    AdminXmTrackingRoutes,
} from '../../config/routes/index';
import VoucherHolderContainer from '../voucher-holder/list/voucher-holder-container';
import { PatientIntakeTabs } from '../recipients/patient-intake/list/nav';
import { SwabShipments } from './fulfillment/pages/swab-shipments';
import { EpletValidation } from '@nkr/views/hla/eplet-validation';
import { EpletValidationDetail } from '@nkr/views/hla/eplet-validation/detail';

interface IProps {
    url: string,
    params: any
}

interface IStateProps {

}

type TProps = IProps & IStateProps;

const AdminContent = (props: TProps) => {
    let { url, params } = props;

    return (
        <div>
            <Switch>
                <Route
                    path={`${url}/dash`}
                    render={({ match: { url, params: dashParams } }) => (
                        <Switch>
                            <Route path={`${url}/donor-intake/to-do`} render={() => <DonorIntake centerId={0} isCenter={false} subSection='TO-DO' isSuperUser={true} />} />
                            <Route path={`${url}/donor-intake/search`} render={() => <DonorIntake centerId={0} isCenter={false} subSection='ALL' isSuperUser={true} />} />
                            <Route path={`${url}/donor-intake/search-by-intended`} render={() => <DonorIntake centerId={0} isCenter={false} subSection='ALL' isSuperUser={true} />} />
                            <Route exact path={`${url}/donor-intake/pwl/details/:id`} render={({ match }) => <DonorIntake centerId={0} regId={match.params.id} isCenter={false} subSection='PWL-DETAILS' isSuperUser={true} />} />
                            <Route exact path={`${url}/donor-intake/details/:id`} render={({ match }) => <DonorIntake centerId={0} regId={parseInt(match.params.id)} isCenter={false} subSection='DETAILS' isSuperUser={true} />} />
                            <Route exact path={`${url}/donor-intake/diagnostics/:id`} render={({ match }) => <DonorIntake centerId={0} regId={parseInt(match.params.id)} isCenter={false} subSection='EDIT-DIAGNOSTICS' isSuperUser={true} />} />
                            <Route path={`${url}/watr/transactions`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='TRANSACTIONS' isSuperUser={true} />} />
                            <Route path={`${url}/watr/year-end`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='YEAR-END' isSuperUser={true} />} />
                            <Route path={`${url}/watr/audit`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='YEAR-END' isSuperUser={true} />} />
                            <Route path={`${url}/watr/search`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='SEARCH' isSuperUser={true} />} />
                            <Route path={`${url}/watr/not-reimbursed`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='NOT-REIMBURSED' isSuperUser={true} />} />
                            <Route path={`${url}/watr/reimbursed`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='REIMBURSED' isSuperUser={true} />} />
                            <Route path={`${url}/watr/donated`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='DONATED' isSuperUser={true} />} />
                            <Route path={`${url}/watr/pend-travel`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-TRAVEL' isSuperUser={true} />} />
                            <Route path={`${url}/watr/pend-receipts`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-RECEIPTS' isSuperUser={true} />} />
                            <Route path={`${url}/watr/pend-wage`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-WAGE' isSuperUser={true} />} />
                            <Route path={`${url}/watr/pend-surgery`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-SURGERY' isSuperUser={true} />} />
                            <Route path={`${url}/watr/pend-wage-to-do`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-WAGE-TO-DO' isSuperUser={true} />} />
                            <Route path={`${url}/watr/pend-travel-to-do`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-TRAVEL-TO-DO' isSuperUser={true} />} />
                            <Route path={`${url}/watr/pend-verify`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-VERIFY' isSuperUser={true} />} />
                            <Route path={`${url}/watr/pend-doc`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-DOC' isSuperUser={true} />} />

                            <Route path={`${url}/watr/pend-lwr-verify`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-LWR-VERIFY' isSuperUser={true} />} />
                            <Route path={`${url}/watr/pend-der-verify`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-DER-VERIFY' isSuperUser={true} />} />

                            <Route path={`${url}/watr/pend-payment`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-PAYMENT' isSuperUser={true} />} />
                            <Route path={`${url}/watr/pend-wire`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-WIRE' isSuperUser={true} />} />
                            <Route path={`${url}/watr/payment-error`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PAYMENT-ERROR' isSuperUser={true} />} />
                            <Route path={`${url}/watr/advanced-reimbursement`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='ADVANCED-REIMBURSEMENT' isSuperUser={true} />} />

                            <Route path={`${url}/watr/pend-payment-to-do`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-PAYMENT-TO-DO' isSuperUser={true} />} />
                            <Route path={`${url}/watr/pend-verify-to-do`} render={() => <WageAndTravel centerId={0} section='WATR' subSection='PEND-VERIFY-TO-DO' isSuperUser={true} />} />
                            <Route path={`${url}/watr/verify/travel/:id`} render={({ match }) => <WageAndTravel centerId={0} section='WATR' subSection='VERIFY' isSuperUser={true} requestId={parseInt(match.params.id)} />} />
                            <Route path={`${url}/watr/verify/wages/:id`} render={({ match }) => <WageAndTravel centerId={0} section='WATR' subSection='VERIFY' isSuperUser={true} requestId={parseInt(match.params.id)} />} />
                            <Route exact path={`${url}/watr`} render={() => <WageAndTravel centerId={0} section='WATR' isSuperUser={true} />} />
                        </Switch>
                    )}
                />

                <Route
                    path={`${url}/patient-intake`}
                    render={({ match: { url, params: dashParams } }) => (
                        <Switch>
                            <Route path={`${url}/to-do`} render={() => <AdminList tab={PatientIntakeTabs.TO_DO} />} />
                            <Route path={`${url}/pending-orders`} render={() => <AdminList tab={PatientIntakeTabs.PENDING_ORDERS} />} />
                            <Route path={`${url}/pending-recipient-profile`} render={() => <AdminList tab={PatientIntakeTabs.PENDING_RECIPIENT_PROFILE} />} />
                            <Route path={`${url}/completed`} render={() => <AdminList tab={PatientIntakeTabs.COMPLETED} />} />
                            <Route path={`${url}/all`} render={() => <AdminList tab={PatientIntakeTabs.ALL} />} />
                        </Switch>
                    )}
                />
                
                <Route path={`${url}/order-tracking`} render={() => <OrderTracking centerId={0} />} />
                <Route path={`${url}/email/sent`} component={NetworkEmailSentList} />
                <Route path={`${url}/hard-to-match`} component={HardToMatch} />
                <Route path={`${url}/email`} component={EmailContainer} />
                <Route path={`${url}/rccap/:id`} component={RccapAddEdit} />
                <Route path={`${url}/rccap`} component={RccapContainer} />
                <Route path={`${url}/centers/:view?`} component={CenterContainer} />
                <Route path={`${url}/cron-jobs`} component={CronJobs} />
                <Route path={`${url}/duty-officer-schedule`} component={DutyOfficerSchedule} />
                <Route path={`${url}/ops-schedule`} component={OpsSchedule} />
                <Route path={`${url}/products`} component={Products} />
                <Route path={`${url}/center-unos-data`} component={AdminCenterUnosData} />
                <Route path={`${url}/recipient-search`} component={RecipientSearch} />
                <Route path={`${url}/language-variable-mapping`} component={DashLanguageVariable} />
                <Route path={`${url}/fail-safe/confirmation/:chainId/:cluster/:position`} component={SwapManagement} />
                <Route path={`${url}/phlebot-tracking`} render={({ match: { params: subParams } }) => <PhlebotReport centerId={0} />} />
                <Route path={`${url}/center/:centerId/account-plan`} render={({ match: { params: subParams } }) => <AccountPlan centerId={subParams.centerId} />} />
                <Route exact path={`${url}/hla/eplet`} component={EpletValidation} />
                <Route exact path={`${url}/hla/eplet/:id`} component={EpletValidationDetail} />
                <Route path={`${url}/hla`} component={Hla} />
                <Route path={`${url}/fulfillment/swab-shipments`} render={() => <SwabShipments />} />

                <Route
                    path={`${url}/opo`}
                    render={({ match: { url, params: opoParams } }) => (
                        <Switch>
                            <Route path={`${url}`} render={() => <OpoList />} />
                        </Switch>
                    )}
                />

                <Route
                    path={`${url}/gps`}
                    render={({ match: { url, params: dashParams } }) => (
                        <Switch>
                            <Route path={`${url}/pend-gps-assign`} render={() => <GpsContainer activeKey='GPS-TRACKING' subKey='PENDING-GPS-ASSIGN' />} />
                            <Route path={`${url}/shipped-to-mc`} render={() => <GpsContainer activeKey='GPS-TRACKING' subKey='SHIPPED-TO-MC' />} />
                            <Route path={`${url}/pending-journey`} render={() => <GpsContainer activeKey='GPS-TRACKING' subKey='PENDING-JOURNEY' />} />
                            <Route path={`${url}/needs-activation`} render={() => <GpsContainer activeKey='GPS-TRACKING' subKey='NEEDS-ACTIVATION' />} />
                            <Route path={`${url}/in-process`} render={() => <GpsContainer activeKey='GPS-TRACKING' subKey='IN-PROCESS' />} />
                            <Route path={`${url}/return-to-nkr`} render={() => <GpsContainer activeKey='GPS-TRACKING' subKey='RETURN-TO-NKR' />} />
                            <Route path={`${url}/pend-nkr-receipt`} render={() => <GpsContainer activeKey='GPS-TRACKING' subKey='PENDING-NKR-RECEIPT' />} />
                            <Route path={`${url}/gps-central`} render={() => <GpsContainer activeKey='GPS-TRACKING' subKey='GPS-CENTRAL' />} />
                            <Route path={`${url}/devices`} render={() => <GpsContainer activeKey='GPS-DEVICES' subKey={null} />} />
                        </Switch>
                    )}
                />

                <Route
                    path={`${url}/follow-up`}
                    render={({ match: { url, params: adminFollowupParams } }) => (
                        <AdminFollowUpRoutes url={url} {...adminFollowupParams} />
                    )}
                />

                <Route
                    path={`${url}/center/:centerId/profile`}
                    render={({ match: { url, params: adminCenterProfileParams } }) => (
                        <AdminCenterProfileRoutes url={url} {...adminCenterProfileParams} />
                    )}
                />

                <Route
                    path={`${url}/invoice`}
                    render={({ match: { url, params: invoiceParams } }) => (
                        <AdminInvoiceRoutes url={url} {...params} />
                    )}
                />

                <Route
                    path={`${url}/report`}
                    render={({ match: { url, params: invoiceParams } }) => (
                        <AdminReportRoutes url={url} {...params} />
                    )}
                />

                <Route
                    path={`${url}/voucher-book`}
                    render={({ match: { url, params: voucherBookParams } }) => (
                        <AdminVoucherBookRoutes url={url} {...params} />
                    )}
                />

                <Route path={`${url}/center-notifications`} render={() => <CenterNotifications />} />

                <Route
                    path={`${url}/donor`}
                    render={({ match: { url, params: donorParams } }) => (
                        <Switch>
                            <Route exact path={`${url}/:donorId/voucher/:voucherHolderId`} render={({ match: { params: subParams } }) =>
                                // <VoucherHolderAddEdit donorId={subParams.donorId} voucherHolderId={subParams.voucherHolderId} centerId={0} isAdmin={true} isAdminLogin={true} />} />
                                <VoucherHolderContainer donorId={subParams.donorId} voucherHolderId={subParams.voucherHolderId} />} />
                        </Switch>
                    )}
                />

                <Route
                    path={`${url}/donors`}
                    render={({ match: { url, params: donorParams } }) => (
                        <Switch>
                            <Route exact path={`${url}/swap`} render={({ match: { params: subParams } }) => <Donors isAdmin={true} centerId={0} activeKey='SWAP' />} />
                            <Route exact path={`${url}`} render={({ match: { params: subParams } }) => <Donors isAdmin={true} centerId={0} activeKey='SWAP' />} />
                        </Switch>
                    )}
                />

                <Route
                    path={`${url}/recipient`}
                    render={({ match: { url, params: recipientParams } }) => (
                        <Switch>
                            <Route exact path={`${url}/:recipientId/profile/antibody-screening`} render={({ match: { params: subParams } }) => <RecipientProfile section='ANTIBODY-SCREENING' centerId={0} recipientId={subParams.recipientId} onUpdateRecipientAlias={() => null} />} />
                        </Switch>
                    )}
                />

                <Route
                    path={`${url}/recipients`}
                    render={({ match: { url, params: recipientParams } }) => (
                        <Switch>
                            <Route exact path={`${url}/voucher-holders`} render={({ match: { params: subParams } }) => <VoucherHolders centerId={0} isAdmin={true} isAdminLogin={true} />} />
                            <Route exact path={`${url}`} render={({ match: { params: subParams } }) => <RecipientList />} />
                        </Switch>
                    )}
                />

                <Route path={`${url}/users`} render={() => <UserList centerId={0} isAdmin={true} />} />
                <Route path={`${url}/user-groups`} component={GroupList} />

                <Route
                    path={`${url}/xm-tracking`}
                    render={({ match: { url, params: xmTrackingParams } }) => (
                        <AdminXmTrackingRoutes url={url} {...params} />
                    )}
                />

                <Route
                    path={`${url}/serology-tracking`}
                    render={({ match: { url, params: xmTrackingParams } }) => (
                        <Route exact path={`${url}`} render={({ match: { params: subParams } }) => <SerologyTracking />} />
                    )}
                />

                <Route
                    path={`${url}/microsite`}
                    render={({ match: { url, params: micrositeParams } }) => (
                        <AdminMicrositeRoutes url={url} {...params} />
                    )}
                />

                <Route
                    path={`${url}/reports`}
                    render={({ match: { url, params: reportParams } }) => (
                        <AdminAllCentersClcReportRoutes url={url} {...params} />
                    )}
                />

                <Route path={`${url}/action-center`} render={() => <ActionCenter />} />

                <Route path={`${url}`} component={NotFound} />
            </Switch>
        </div>
    );
}

export default AdminContent;